
import React from 'react';
import AdminLayout from './AdminLayout';
import EventsListPanel from '@/components/admin/EventsListPanel';
import EventStatisticsPanel from '@/components/admin/EventStatisticsPanel';

const EventsManagement = () => {
  return (
    <AdminLayout>
      <div className="p-6 space-y-6">
        <h1 className="text-2xl font-bold">Események kezelése</h1>
        <div className="grid grid-cols-1 gap-6">
          <EventsListPanel />
          <EventStatisticsPanel />
        </div>
      </div>
    </AdminLayout>
  );
};

export default EventsManagement;
